if (!window.vf) {
    window.vf = {};
}

vf['condition-content-loader'] = (function () {
    'use strict';
    if (!Mustache) {
        console.error('condition-content-loader needs Mustache');
        return null;
    }

    function loadTemplate(templateUrl) {

        return $.ajax({
            'url': templateUrl
        });

    }

    function appendToDoc(data, config) {
        if ('' !== config.appendTo && 'undefined' !== (typeof config.appendTo)) {
            $(config.appendTo || 'body').append(data);
            return true;
        } else if ('' !== config.prependTo) {
            $(config.prependTo || 'body').prepend(data);
            return true;
        }
        return false;
    }

    function postJavascript(config) {
        if (!config.type || 'string' !== (typeof config.type)) {
            return true;
        }
        var objArr = config.type.split('.');
        objArr.push('init');
        var currObj = window;
        for (var i = 0; i < objArr.length; i++) {
            var key = objArr[i];
            if (currObj[key] && (i + 1) === objArr.length && 'function' === (typeof currObj[key])) {
                currObj[key](config);
                return true;
            } else if (currObj[key]) {
                currObj = currObj[key];
            } else {
                return false;
            }
        }
        return false;
    }

    function init(config) {
        var promise = $.Deferred();


        if (!config || !config.dataurl) {
            return promise.reject('Can not load Condition content. No config or no config dataurl');
        }
        loadTemplate(config.dataurl).then(function (templateData) {
            var data = '';
            try {
                data = Mustache.render(templateData, config.data || {});
            } catch (e) {
                console.warn('Error with global data template', templateData, e);
                data = templateData;
            } finally {
                appendToDoc(data, config);
                promise.resolve(data);
                postJavascript(config);
            }
        });
        return promise;
    }

    return {
        'init': init
    };
})();
